
import { defineComponent, onMounted, ref } from 'vue'

export default defineComponent({
    name: 'Animate',
    props: {
        animationType: {
            type: String,
            required: false,
            default: 'fade',
        },
        className: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup() {
        const target = ref()
        const animate = ref(false)

        const observer = new IntersectionObserver(
            ([entry]) => {
                animate.value = entry.isIntersecting
            },
            {
                threshold: 0.1,
            }
        )

        onMounted(() => {
            observer.observe(target.value)
        })

        return {
            animate,
            target,
        }
    },
})
